<!--
グラフ選択画面
URL：/graph/umilog
-->

<template>
  <div>
    <v-container>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">表示データ：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            placeholder="表示データを選択して下さい"
            v-model="graphKindName"
            :items="dispDataItems"
            @input="onInput"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto" style="padding: 0px; width: 200px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            v-model="dispYear1"
            :items="selectDispYears1"
          ></v-select>
        </v-col>
        <v-col cols="auto" style="padding: 0px;">
          <v-btn
            color="primary"
            style="font-size: 24px"
            class="ml-4"
            width="200"
            height="50"
            @click="dispGraph"
            >表示</v-btn
          >
        </v-col>
      </v-row>
      <v-divider style="margin: 20px"></v-divider>

      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 155px; height: 70px">
          <v-card-title class="custom-card-title">観測地点：</v-card-title>
        </v-col>
        <v-col cols="auto" style="padding: 0px; width: 280px; height: 70px">
          <v-select
            outlined
            color="#0ddbc7"
            v-model="observation"
            :items="dispObservationItems"
            @input="onSelectObservation"
          ></v-select>
        </v-col>
      </v-row>
      <div>
        <graph-output-umilog ref="graph_op"></graph-output-umilog>
      </div>
    </v-container>
  </div>
</template>

<script>
import graphOutputUmilog from "../../components/graph-sub-contents/graph-output-umilog.vue";
import Api from "@/logic/api/api.js";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";
import ValueConverer from "../../logic/common/value-converter";

export default {
  components: {
    "graph-output-umilog": graphOutputUmilog,
    alert: Alert,
  },
  data() {
    this.graphKindName = "";
    this.selectDispYears1 = [];
    this.selectDispYears2 = [];
    this.dispYear1 = "";
    this.dispYear2 = "";

    this.summary_type = "";
    this.summary_year = [];

    // 表示・非表示フラグ
    this.dispFlag = {
      // グラフ
      graph: false,
      // 観測地点
      observation: 1,
      // 平年値
      average: true,
    };

    this.$nextTick(() => {
      this.getLocationIdList();
    });

    // 出力メッセージ領域クリア
    this.clearMessage();

    // 表示年1リスト作成(現在からシステム基準年(2021年)までの西暦と和暦を詰める)
    var today = new Date();
    var nowYear1 = today.getFullYear();
    for (var count1 = 0; count1 <= nowYear1 - 2021; count1++) {
      var nowYearJP1 = "(令和" + (nowYear1 - count1 - 2018) + ")";
      this.selectDispYears1[count1] = nowYear1 - count1 + nowYearJP1 + "年";
    }
    // 表示年2リスト作成(一昨年からシステム基準年(2021年)までの西暦と和暦を詰める)
    var nowYear2 = today.getFullYear() - 1;
    for (var count2 = 0; count2 <= nowYear2 - 2021; count2++) {
      var nowYearJP2 = "(令和" + (nowYear2 - count2 - 2018) + ")";
      this.selectDispYears2[count2] = nowYear2 - count2 + nowYearJP2 + "年";
    }

    // 観測地点（うみログデバイス）保持用
    this.saveObservationItems = [];

    // 観測地点デバイスID保持用配列(海洋情報、積算水温、20℃超過日数)
    this.locationIds = [0,0,0];

    // 観測地点初期値（観音）
    this.observation = [
      {
        text: "観音",
        value: 0,
      },
    ];

    var dispDataItems = [
      "日平均水温の推移",
      "日平均クロロフィルの推移",
      "日平均塩分の推移",
      "日平均溶存酸素の推移",
      "積算水温の表示",
      "20℃超過日数の表示",
    ];

    return {
      errors: [],
      // 表示データ
      graphKindName: dispDataItems[0],
      // 表示データリスト設定
      dispDataItems: dispDataItems,
      // 表示年1リスト設定
      dispYear1: this.selectDispYears1[0],
      // 表示年2リスト設定
      dispYear2: this.selectDispYears2[0],
      // ユーザーリスト設定
      dispProducerItems: this.dispProducerItems,
      // 観測地点一覧リスト設定
      dispObservationItems: [],
      // 表示・非表示フラグ
      dispFlag: this.dispFlag,
    };
  },
  methods: {
    /**
     * 選択ボックスの表示・非表示の切り替えおよびグラフ種別の設定
     */
    onInput() {
      // 観測地点の再構築
      this.getLocationIdList();

      // グラフ表示フラグの初期化
      this.dispFlag = this.resetdispFlag();

      // グラフ表示オプションの初期化
      this.$refs.graph_op.resetChartOptions();

      switch (this.graphKindName) {
        case "日平均水温の推移":
          {
            this.dispFlag.observation = 1;
            this.dispFlag.average = true;
            return;
          }
        case "日平均クロロフィルの推移":
        case "日平均塩分の推移":
        case "日平均溶存酸素の推移":
          {
            this.dispFlag.observation = 2;
            this.dispFlag.average = false;
            return;
          }
        case "積算水温の表示":
          {
            this.dispFlag.observation = 3;
            this.dispFlag.average = false;
            return;
          }
        case "20℃超過日数の表示":
          {
            this.dispFlag.observation = 4;
            this.dispFlag.average = true;
            return;
          }
      }
    },
    /**
     * 生産集計情報を取得する
     */
    getRequestPostdata() {
      // 各表示年を集計年リストに格納
      var summaryYear1 = { comparison_year: "" };
      var summaryYear2 = { comparison_year: "" };
      var summaryYear = [];
      summaryYear1.comparison_year = this.dispYear1.slice(0, 4);
      summaryYear.push(summaryYear1);
      summaryYear2.comparison_year = this.dispYear2.slice(0, 4);
      summaryYear.push(summaryYear2);

      // 表示対象種別毎に取得用パラメータ生成
      switch (this.graphKindName) {
        case "日平均水温の推移":
          return {
            summary_type: "WATERTEMP",
            summary_year: summaryYear,
            location_id: this.locationIds[0],
          };
        case "日平均クロロフィルの推移":
          return {
            summary_type: "CHLOROPHYLL",
            summary_year: summaryYear,
            location_id: this.locationIds[0],
          };
        case "日平均塩分の推移":
          return {
            summary_type: "SALINITY",
            summary_year: summaryYear,
            location_id: this.locationIds[0],
          };
        case "日平均溶存酸素の推移":
          return {
            summary_type: "OXYGEN",
            summary_year: summaryYear,
            location_id: this.locationIds[0],
          };
        case "積算水温の表示":
          // 表示年2は表示年1の前年固定
          summaryYear[1].comparison_year = String(Number(this.dispYear1.slice(0, 4)-1));
          return {
            summary_type: "INTEGRATED",
            summary_year: summaryYear,
            location_id: this.locationIds[1],
          };
        case "20℃超過日数の表示":
          // 表示年2は表示年1の前年固定
          summaryYear[1].comparison_year = String(Number(this.dispYear1.slice(0, 4)-1));
          return {
            summary_type: "DAYSOVER20",
            summary_year: summaryYear,
            location_id: this.locationIds[2],
          };
      }
    },
    /**
     * グラフを表示する
     */
    dispGraph() {
      // メッセージ領域をクリアする
      this.clearMessage();

      // 入力値チェック
      if (this.graphKindName == "") {
        this.showMessage(AlertBuilder.error("表示データを選択してください"));
      } else {
        // グラフ出力用のデータを収集する
        this.getData();
      }
    },
    /**
     * うみログデバイスID一覧を取得する
     */
    getLocationIdList() {
      this.clearMessage();

      // 積算水温向け観測地点一覧
      const integratedItems = [
        {
          text: "広島湾北部",
          value: 4,
        },
        {
          text: "江田島湾内",
          value: 7,
        },
        {
          text: "広島湾西部",
          value: 2,
        },
      ];

      // 積算水温以外の観測地点一覧
      const integratedOtherItems = [
        {
          text: "玖波",
          value: 1,
        },
        {
          text: "大野",
          value: 2,
        },
        {
          text: "地御前",
          value: 3,
        },
        {
          text: "草津",
          value: 4,
        },
        {
          text: "坂",
          value: 5,
        },
        {
          text: "奈佐美",
          value: 6,
        },
        {
          text: "江田島湾",
          value: 7,
        },
        {
          text: "阿多田島",
          value: 8,
        },
        {
          text: "大黒神島",
          value: 9,
        },
        {
          text: "東江",
          value: 10,
        },
        {
          text: "大柿",
          value: 11,
        },
        {
          text: "音戸",
          value: 12,
        },
        {
          text: "倉橋",
          value: 13,
        },
        {
          text: "安浦",
          value: 14,
        },
        {
          text: "安芸津",
          value: 15,
        },
        {
          text: "御床",
          value: 16,
        },
      ];

      if (this.graphKindName=="積算水温の表示") {
        this.dispObservationItems = integratedItems;
        this.setObservation();

      } else {
        this.dispObservationItems = integratedOtherItems;
        this.setObservation();

      }
    },
    /**
     * グラフ出力用のデータを収集する
     */
    getData() {
      if (this.graphKindName) {
        // 生産集計情報取得APIを呼ぶ
        let postData = this.getRequestPostdata();

        if(postData.location_id == 0){
          this.showMessage(AlertBuilder.error("観測地点を選択してください"));
        }else{
          this.$store.commit("setWaiting", true);

          Api.call("/umilog/sensorlogs/summary/get", postData)
            .then((result) => {
              this.$store.commit("setWaiting", false);
              this.summary_type = result.summary_type;
              this.summary_data = result.summary_data;

              // グラフ出力用のデータを設定する
              this.setData();
            })
            .catch((error) => {
              this.$store.commit("setWaiting", false);
              const message = valueMapper
                .map({
                  400: AlertBuilder.error("取得に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
              if (message.isInvalid) {
                Api.resolve(error);
              } else {
                this.showMessage(message);
              }
            });

        }
      }
    },
    /**
     * グラフ出力用のデータを設定する
     */
    setData() {
      // グラフ出力フラグON
      this.dispFlag.graph = true;

      // グラフ情報を設定する
      this.$refs.graph_op.setOutputData(
        // 表示データ(グラフの種類)
        this.graphKindName,
        // 表示年1
        this.dispYear1.slice(0, 4),
        // 表示年2
        this.dispYear2.slice(0, 4),
        // API取得集計データ
        this.summary_data,
      );
    },
    /**
     * 表示データに合わせて観測地点リストを作成
     */
    setObservationItems(result) {
      var cnt = 0;
      var locationListSub = [];

      for (const location of result.location) {
        locationListSub[cnt++] = location
      }
      this.dispObservationItems = ValueConverer.locationForSelectbox(locationListSub);

      // DBから取得したうみログデバイス一覧を保持しておく
      this.saveObservationItems = this.dispObservationItems;
    },
    /**
     * 観測地点を設定する
     */
    setObservation() {
      var index = 0;
      this.locationIds = [];
      this.locationIds = this.stringToNumArr(this.$store.getters.locationId);

      // DBの値に不正がある場合は初期値をストアおよびDBに反映させておく
      if (this.locationIds.length < 3) {
        this.locationIds = [0, 0, 0];

        // Storeデータ更新
        this.$store.commit("setLocationId", this.numArrToString(this.locationIds) || "0,0,0");

        // 観測地点更新
        this.updateObservation();
      }

      switch (this.graphKindName) {
        case "日平均水温の推移":
        case "日平均クロロフィルの推移":
        case "日平均塩分の推移":
        case "日平均溶存酸素の推移":
          index = this.dispObservationItems.findIndex(item => item.value === this.locationIds[0]);
          break;
        case "積算水温の表示":
          index = this.dispObservationItems.findIndex(item => item.value === this.locationIds[1]);
          break;
        case "20℃超過日数の表示":
          index = this.dispObservationItems.findIndex(item => item.value === this.locationIds[2]);
          break;
      }

      // ユーザーが保持している値を設定
      this.observation = this.dispObservationItems[index];
    },
    /**
     * 観測地点および表示グラフを更新する
     */
    onSelectObservation() {
      // メッセージ領域をクリアする
      this.clearMessage();

      // グラフ出力フラグON
      this.dispFlag.graph = true;

      switch (this.graphKindName) {
        case "日平均水温の推移":
        case "日平均クロロフィルの推移":
        case "日平均塩分の推移":
        case "日平均溶存酸素の推移":
          this.locationIds[0] = this.observation;
          break;
        case "積算水温の表示":
          this.locationIds[1] = this.observation;
          break;
        case "20℃超過日数の表示":
          this.locationIds[2] = this.observation;
          break;
      }

      // Storeデータ更新
      this.$store.commit("setLocationId", this.numArrToString(this.locationIds) || "0,0,0");

      // 観測地点を設定する
      this.setObservation();

      // グラフデータを収集・表示
      this.getData();

      // 観測地点更新
      this.updateObservation();
    },
    /**
     * 表示・非表示フラグリセット
     */
    resetdispFlag() {
      return {
        graph: false,
        observation: 1,
      };
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * カンマ区切り文字列を数値配列に分解
     */
    stringToNumArr(str) {
      return str.split(',').map(str => parseInt(str, 10));
    },
    /**
     * 数値配列をカンマ区切り文字列に結合
     */
    numArrToString(arr) {
      return arr.join();
    },
    /**
     * 観測地点更新
     */
    updateObservation() {
      // メッセージ領域をクリアする
      this.clearMessage();

      // 送信データを作成する
      const postData = {
        update_request: [{
            uid: this.$store.getters.userId,
            location_id: this.$store.getters.locationId,
        },
      ]};

      // 観測地点を更新する
      this.$store.commit("setWaiting", true);
      Api.call("/admin/user/locationid/update", postData)
            .then((result) => {
              this.$store.commit("setWaiting", false);
              const message = valueMapper
                .map({
                  failed: AlertBuilder.error("観測地点の更新に失敗しました"),
                })
                .get(result.message);
              if (message) {
                this.errors.push(message);
              }
            })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    },
  },
};
</script>

<style></style>
